var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99854 12C3.99854 7.58091 7.58091 3.99854 12 3.99854C16.4191 3.99854 20.0015 7.58091 20.0015 12C20.0015 16.4191 16.4191 20.0015 12 20.0015C7.58091 20.0015 3.99854 16.4191 3.99854 12ZM12 2.99854C7.02863 2.99854 2.99854 7.02863 2.99854 12C2.99854 16.9714 7.02863 21.0015 12 21.0015C16.9714 21.0015 21.0015 16.9714 21.0015 12C21.0015 7.02863 16.9714 2.99854 12 2.99854ZM11.5 16.5C11.5 16.7761 11.7239 17 12 17C12.2761 17 12.5 16.7761 12.5 16.5V10C12.5 9.72386 12.2761 9.5 12 9.5C11.7239 9.5 11.5 9.72386 11.5 10V16.5ZM11.5 7.51331C11.5 7.78945 11.7239 8.01331 12 8.01331C12.2761 8.01331 12.5 7.78945 12.5 7.51331V7.5C12.5 7.22386 12.2761 7 12 7C11.7239 7 11.5 7.22386 11.5 7.5V7.51331Z",
    fill: "#6D6970"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInfo);
export default __webpack_public_path__ + "static/media/ico-Info.75d8004e73fd80a89ba07f76b065e010.svg";
export { ForwardRef as ReactComponent };